var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSendColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7835 12.7334C13.4521 12.4848 12.982 12.552 12.7335 12.8834C12.485 13.2147 12.5521 13.6848 12.8835 13.9334L13.7835 12.7334ZM24.4502 13.9334C24.7815 13.6848 24.8487 13.2147 24.6002 12.8834C24.3516 12.552 23.8815 12.4848 23.5502 12.7334L24.4502 13.9334ZM18.0668 16.8834L17.6168 17.4834L18.0668 16.8834ZM19.2668 16.8834L18.8168 16.2834L19.2668 16.8834ZM12.8835 13.9334L17.6168 17.4834L18.5168 16.2834L13.7835 12.7334L12.8835 13.9334ZM19.7168 17.4834L24.4502 13.9334L23.5502 12.7334L18.8168 16.2834L19.7168 17.4834ZM17.6168 17.4834C18.2391 17.95 19.0946 17.95 19.7168 17.4834L18.8168 16.2834C18.7279 16.35 18.6057 16.35 18.5168 16.2834L17.6168 17.4834Z",
    fill: "#1E208D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 21.3333,
    height: 16,
    rx: 4,
    stroke: "#1E208D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 12L4 12",
    stroke: "#00C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 20L4 20",
    stroke: "#00C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 16H2.6665",
    stroke: "#00C0C0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSendColor);
export default __webpack_public_path__ + "static/media/email-send-color.2570eba82e67d4a48ea97b74fcb758f0.svg";
export { ForwardRef as ReactComponent };